<template>
  <v-form v-model="valid" ref="mainForm">
    
    <opq-catalogue
      code="enquete_revelationidentite"
      v-model="sasDemandeEnquete.anonymat"
      :live="liveSasDemandeEnquete(23337)"
    ></opq-catalogue>

    <opq-case
      code="enquete_renseignementsexacts"
      v-model="sasDemandeEnquete.certificationDeclaration"
      :live="liveSasDemandeEnquete(23340)"
    ></opq-case>
  </v-form>
</template>

<script>
import FormSimple from "@/mixins/FormSimple"
import CataloguesHelper from "@/mixins/CataloguesHelpers"

export default {
  mixins: [FormSimple, CataloguesHelper],
  props: {
    sas: { type: Object }
  },

  computed: {
    sasDemandeEnquete() {
      return this.sas.sasDemandeEnquete
    },
  },

  methods: {
    liveSasDemandeEnquete(cle) {
      return { endpoint: "/sas-demande-enquete/", cle: cle, fileId: this.sasDemandeEnquete.id }
    }
  }
}
</script>

<style>
</style>